import { RouteItem } from '@eastcoal/router/types/route'

import { ORDER_COMPLAINT_LIST_PAGE_PATH } from './constants/path'
import { ORDER_COMPLAINT_ACTION_UUID } from './constants/uuid'

export const orderComplaintRoute: RouteItem = {
  title: '订单投诉',
  hideChildrenInMenu: true,
  children: [
    {
      title: '订单投诉列表',
      path: ORDER_COMPLAINT_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '处理投诉',
      uuid: ORDER_COMPLAINT_ACTION_UUID
    }
  ]
}
